export const isDateTimeInPast = (date, time) => {
    if (!date || !time) return false;
    
    const selectedDateTime = new Date(`${date}T${time}`);
    const now = new Date();
    
    // Add a small buffer (2 minutes) to allow for form submission
    now.setMinutes(now.getMinutes() - 2);
    
    return selectedDateTime < now;
  };